import { useSyncExternalStore } from 'react';

import type { StyliticsJumpLinkState } from '~/components/shared/recommendations/stylitics/types';

// The composer (StyliticsRecommendations) and the JumpLink (image gallery) live in
// separate, independently loaded subtrees. A module-level store keeps the latest
// composer result, so a JumpLink that mounts after `load.composer` still reads it.
const HIDDEN: StyliticsJumpLinkState = { hidden: true };

let state = HIDDEN;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};

const getSnapshot = () => state;
const getServerSnapshot = () => HIDDEN;

export const setJumpLinkState = (nextState: StyliticsJumpLinkState): void => {
  state = nextState;
  listeners.forEach(listener => listener());
};

export const resetJumpLinkState = (): void => setJumpLinkState(HIDDEN);

export const useJumpLinkState = (): StyliticsJumpLinkState =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
